import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=d11e9e6a&scoped=true"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11e9e6a",
  null
  
)

export default component.exports